<div class="dashmap" [class.tooltip-map-moving]="tooltipMapMoving" *blockUI="'section-block'">
    <!-- Google Maps Marker Circle Polygon Component -->
    <google-map *ngIf="markersLoaded"
        [options]="mapOptions" 
        [height]="mapHeight"
        width="'100%'"
        [center]="markerCirclePolygonCenter"
        [zoom]="markerCirclePolygonZoom"
        (mapDragstart)="onMapDragStart()"
        (mapDragend)="onMapDragEnd()"
        (zoomChanged)="onMapZoomChanged()"
        (boundsChanged)="scheduleTooltipConnectorUpdate(true)"
        (idle)="onMapIdle()"
    >
        <!-- <map-circle [options]="mapCircleOptions" [center]="mapCircleCenter"></map-circle> -->
        <!-- <map-polygon [options]="mapPolygonOptions" [paths]="mapPolygonPaths"></map-polygon> -->
        <map-marker *ngFor="let marker of iconMarkers" [position]="marker.position" [options]="marker" (mapClick)="marker.onclick()"></map-marker>
        <ng-container *ngFor="let marker_ of (showMapMarkers ? markers : []); trackBy: trackByMarker">
            <ng-container *ngIf="marker_['infoWindow']; else normalMarker">
                <map-marker #alarmMarker="mapMarker" [position]="marker_.position" [options]="marker_" (mapClick)="bringInfoWindowToFront(infoWindow); marker_.onclick()"></map-marker>
                <map-info-window #infoWindow="mapInfoWindow" [position]="marker_.infoWindow.position" [options]="marker_.infoWindow" (closeclick)="closeInfoWindow(marker_, infoWindow)">
                    <!-- Tooltip automático de alarmas usado por new-dashboard y el mapa nuevo. -->
                    <article #alarmTooltip class="siac-alarm-tooltip"
                        [attr.data-location-id]="marker_.location_id"
                        [attr.data-device-id]="marker_.device_id"
                        [class.alarm-chart-tooltip]="marker_.location_type_id === 3 || [4, 8, 9].includes(marker_.location_type_id)"
                        [class.transformer-alarm-tooltip]="marker_.location_type_id === 4"
                        (mousedown)="bringInfoWindowToFront(infoWindow)"
                        *ngIf="hideGoogleMapControls; else legacyAlarmTooltip">
                        <button type="button" class="close-btn" (click)="closeInfoWindow(marker_, infoWindow)" aria-label="Cerrar detalle">×</button>
                        <header>
                            <span><i class="fa fa-exclamation-triangle"></i> {{getMarkerTooltipEyebrow(marker_)}}</span>
                                <strong>{{getMarkerTooltipTitle(marker_)}}</strong>
                        </header>

                        <!-- Sección Tipo/Dispositivo temporalmente oculta.
                        <div class="alarm-tooltip-data">
                            <div><small>Tipo</small><b>{{getMarkerDeviceType(marker_)}}</b></div>
                            <div><small>Dispositivo</small><b>{{getMarkerDeviceName(marker_)}}</b></div>
                        </div>
                        -->
                        <p>{{getMarkerAlarmMessage(marker_)}}</p>
                        <div class="alarm-source-type">
                            <span>
                                <i class="fa fa-microchip" aria-hidden="true"></i>
                                <small>Activo:</small>
                                <strong>{{getMarkerAlarmAssetType(marker_)}}</strong>
                            </span>
                            <span>
                                <i class="fa fa-bolt" aria-hidden="true"></i>
                                <small>Fuente:</small>
                                <strong>{{getMarkerAlarmSensorType(marker_)}}</strong>
                            </span>
                        </div>
                        <div class="alarm-created">
                            <small>{{getPrimaryMarkerAlarm(marker_)?.create_date | date:'dd/MM/yyyy HH:mm:ss'}}</small>
                        </div>

                        <!-- CÁMARAS (location_type_id = 7): captura asociada a la alarma. -->
                        <swiper-container *ngIf="marker_.location_type_id === 7 && marker_.infoWindow.slides?.length"
                            class="alarm-camera-preview" [pagination]="true" [options]="slideOpts">
                            <swiper-slide *ngFor="let slide of marker_.infoWindow.slides">
                                <img class="slide-img" [src]="slide.img" alt="Captura asociada a la alarma">
                            </swiper-slide>
                        </swiper-container>

                        <!-- ZONAS (3) Y EQUIPOS MONITOREADOS (4, 8, 9): gráfico compacto de alarmas. -->
                        <div class="chart-container" *ngIf="marker_.location_type_id === 3 || [4, 8, 9].includes(marker_.location_type_id)">
                            <app-zone-step-line
                                [locationId]="marker_.location_id"
                                [alarmList]="marker_.alarmList"
                                [compact]="true"
                                [compactHeight]="160">
                            </app-zone-step-line>
                        </div>

                        <footer>
                            <!-- En un grupo, el botón acerca el mapa para separar sus dispositivos. -->
                            <button type="button" (click)="marker_.onclick()">{{(marker_.groupDeviceCount || 1) > 1 ? 'Ver dispositivos' : 'Ver detalle'}} <i class="fa" [ngClass]="(marker_.groupDeviceCount || 1) > 1 ? 'fa-search-plus' : 'fa-external-link'"></i></button>
                        </footer>
                    </article>

                    <!-- Tooltips originales del dashboard antiguo. -->
                    <ng-template #legacyAlarmTooltip>
                        <ng-container [ngSwitch]="marker_.location_type_id">
                            <!-- CÁMARAS (location_type_id = 7). -->
                            <div *ngSwitchCase="7" class="info-window">
                                <a href="javascript:void(0)" class="close-btn" (click)="closeInfoWindow(marker_, infoWindow)">x</a>
                                <swiper-container [pagination]="true" [options]="slideOpts">
                                    <swiper-slide *ngFor="let slide of marker_.infoWindow.slides">
                                        <img class="slide-img" [src]="slide.img">
                                    </swiper-slide>
                                </swiper-container>
                                <a href="javascript:void(0);" class="expand-camera-btn" (click)="marker_.onclick()">
                                    <i class="feather icon-maximize" data-feather="maximize" stroke-width="4" style="width: 32px; height:32px"></i>
                                </a>
                            </div>
                            <!-- ZONAS (location_type_id = 3). -->
                            <div *ngSwitchCase="3" class="info-window-chart">
                                <a href="javascript:void(0)" class="close-btn" (click)="closeInfoWindow(marker_, infoWindow)">x</a>
                                <div class="chart-container">
                                    <app-zone-step-line [locationId]="marker_.location_id" [alarmList]="marker_.alarmList" [compact]="true"></app-zone-step-line>
                                </div>
                                <a href="javascript:void(0);" class="expand-camera-btn" (click)="marker_.onclick()">
                                    <i class="feather icon-maximize" data-feather="maximize" stroke-width="4" style="width: 32px; height:32px"></i>
                                </a>
                            </div>
                            <ng-container *ngSwitchDefault>
                                <!-- TRANSFORMADORES, CAMIONETAS Y PALAS (location_type_id = 4, 8, 9). -->
                                <div class="info-window-chart" *ngIf="[4, 8, 9].includes(marker_.location_type_id)">
                                    <a href="javascript:void(0)" class="close-btn" (click)="closeInfoWindow(marker_, infoWindow)">x</a>
                                    <div class="chart-container">
                                        <app-zone-step-line [locationId]="marker_.location_id" [alarmList]="marker_.alarmList" [compact]="true"></app-zone-step-line>
                                    </div>
                                    <a href="javascript:void(0);" class="expand-camera-btn" (click)="openTransformerAlarmModal($event, marker_)">
                                        <i class="feather icon-maximize" data-feather="maximize" stroke-width="4" style="width: 32px; height:32px"></i>
                                    </a>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                </map-info-window>
            </ng-container>
            <ng-template #normalMarker>
                <map-marker [position]="marker_.position" [options]="marker_" (mapClick)="marker_.onclick()"></map-marker>
            </ng-template>
        </ng-container>
        <map-polyline *ngFor="let polyLine of (showMapLines ? polyLines : []); trackBy: trackByPolyLine" [options]="polyLine" [path]="polyLine.path" (polylineClick)="polyLine.onclick()"></map-polyline>
        <!-- Triángulos adaptables: su base nace en la tarjeta y el vértice señala el marcador. -->
        <map-polygon *ngFor="let connector of tooltipConnectors; trackBy: trackByTooltipConnector"
            [options]="connector" [paths]="connector.path">
        </map-polygon>
    </google-map>
    <!--/ Google Maps Marker Circle Polygon Component -->

    <ng-container *ngIf="isFullscreen">
        <div ngxDraggableDom="true">
            <ng-content select="[fullscreen-bottom]">

            </ng-content>
        </div>
        <div ngxDraggableDom="true">
            <ng-content select="[fullscreen-bottom-right]">

            </ng-content>
        </div>
    </ng-container>

    <div id="mapLegend"  ngxDraggableDom="true" [hidden]="!mapLegendLoaded">
        <!-- <h2>Leyenda</h2> -->
    <div class="legend" *ngFor="let data of colors">
        <span class="icon-color" [style.background-color]="data.hex"></span>
        <span class="legend-text">{{data.name}}</span>
    </div>
    </div>

  

    <!-- Modal -->
    <ng-template #modalTemplate let-modal>
        <div class="modal-header siac-location-header" *ngIf="modalData?.type !== 'transformer'">
            <div>
                <small>{{getLocationTypeLabel(modalData?.location)}}</small>
                <h5 class="modal-title">{{modalData?.location?.name || modalData?.location?.description || 'Detalle de ubicación'}}</h5>
            </div>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <ng-container [ngTemplateOutlet]="dataTemplate"
                          [ngTemplateOutletContext]="{ $implicit: modalData, modal: modal }"></ng-container>
        </div>

        <div class="modal-footer" *ngIf="modalData?.type !== 'transformer' && modalData?.type !== 'variable'">
            <button type="button" class="btn btn-primary" (click)="modal.close('Accept click')" rippleEffect>
                Aceptar
            </button>
        </div>
    </ng-template>

    <ng-template #dataTemplate let-data let-modal="modal">
        <div [ngSwitch]="data['type']">
        <!-- SENSORES, GATEWAYS Y RELAYS: datos actuales del dispositivo. -->
        <app-device-popover *ngSwitchCase="'device-popover'" [location]="data['location']" [device]="data['device']"></app-device-popover>
        <!-- CÁMARAS: historial de alarmas y capturas. -->
        <app-camera-modal *ngSwitchCase="'camera'" [location]="data['location']" [device]="data['device']"></app-camera-modal>
        <!-- ZONAS: historial y gráfico de variación. -->
        <app-variable-history *ngSwitchCase="'variable'" [location]="data['location']"
            [device]="data['device']"
            (closeRequested)="modal.close('Zone details close')"></app-variable-history>
        <!-- TRANSFORMADORES, CAMIONETAS Y PALAS: monitoreo completo del activo. -->
        <app-battery-voltage-modal *ngSwitchCase="'transformer'"
            [location]="data['location']"
            [device]="data['device']"
            [alarmList]="data['alarmList'] || []"
            [initialTab]="data['initialTab'] || 'history'"
            [markerIconUrl]="data['markerIconUrl']"
            (closeRequested)="modal.close('Asset monitor close')">
        </app-battery-voltage-modal>
        <!-- TIPOS SIN COMPONENTE ESPECIALIZADO: resumen genérico. -->
        <section *ngSwitchCase="'generic'" class="siac-location-fallback">
            <i class="fa fa-map-marker"></i>
            <h3>{{data['location']?.name || 'Ubicación sin nombre'}}</h3>
            <p>{{data['location']?.description || 'No existen datos adicionales configurados para esta ubicación.'}}</p>
            <dl>
                <dt>Tipo</dt><dd>{{getLocationTypeLabel(data['location'])}}</dd>
                <dt>Estado</dt><dd>{{statusMap[data['location']?.siac_status_id] || 'Sin datos'}}</dd>
            </dl>
        </section>
        </div>
    </ng-template>
</div>
